export const useGlobalComponentStore = definePiniaStore(
  "globalComponentStore",
  {
    state: () => ({
      _tableFilter: false,
      _showMoreModal: false,
    }),
    getters: {
      tableFilter: (state) => state._tableFilter,
      showMoreModal: (state) => state._showMoreModal,
    },
    actions: {
      toggleTableFilter() {
        this.$state._tableFilter = !this.$state._tableFilter;
      },
      setShowMoreModalVisibility(bool: boolean) {
        this.$state._showMoreModal = bool;
      },
    },
  },
);
